import AccessContentModal, { MESSAGE_TYPE } from './AccessContentModal';

export { AccessContentModal, MESSAGE_TYPE };
export default AccessContentModal;
